module.exports = __webpack_public_path__ + "static/media/Lecture.d59afc9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/ListBox/components/HitListModal/components/Table/Lecture.svg
// module id = 152
// module chunks = 0